"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface DropdownMenuProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
  menuStyle?: React.CSSProperties;
  backdropTestId?: string;
  role?: string;
}
export const DropdownMenu: React.FC<DropdownMenuProps> = t0 => {
  const $ = _c(19);
  const {
    isOpen,
    onClose,
    children,
    style: t1,
    menuStyle: t2,
    backdropTestId,
    role: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const style = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const menuStyle = t5;
  const role = t3 === undefined ? "menu" : t3;
  if (!isOpen) {
    return null;
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      position: "fixed",
      inset: 0,
      zIndex: 999
    };
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== backdropTestId || $[6] !== onClose) {
    t7 = <div data-testid={backdropTestId} onClick={onClose} style={t6} />;
    $[5] = backdropTestId;
    $[6] = onClose;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== menuStyle || $[9] !== style) {
    t8 = {
      position: "absolute",
      top: "calc(100% + 0.75rem)",
      insetInlineEnd: 0,
      zIndex: 1000,
      animation: "dropdownFadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
      ...style,
      ...menuStyle
    };
    $[8] = menuStyle;
    $[9] = style;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== children || $[12] !== role || $[13] !== t8) {
    t9 = <div role={role} className="rounded-3xl shadow-xl border border-black/[0.05] dark:border-white/[0.05] overflow-hidden bg-white dark:bg-[#1D1D1F]" style={t8}>{children}</div>;
    $[11] = children;
    $[12] = role;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <style jsx={true}>{"\n        @keyframes dropdownFadeIn {\n          from {\n            opacity: 0;\n            transform: translateY(10px) scale(0.98);\n          }\n          to {\n            opacity: 1;\n            transform: translateY(0) scale(1);\n          }\n        }\n      "}</style>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t7 || $[17] !== t9) {
    t11 = <>{t7}{t9}{t10}</>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};